export const THRESHOLD_INFINITE_SCROLL = 4;
export const HEADER_TABLE_HEIGHT = 86;
export const FOOTER_TABLE_HEIGHT = 160;
export const OWN_ACCOUNT_NAME = 'My Reservations';
export const MAX_RESERVATIONS = 10;
export const FARTHEST_RESERVATION_DAY_OFFSET = 14;
